import get from 'lodash/get'

export const getFieldError = (formState, fieldName) => get(formState.errors, fieldName)
